module.exports = __webpack_public_path__ + "static/media/course-1.81bd83ac.png";